module.exports = __webpack_public_path__ + "static/media/FacebookIcon.5fea6643.svg";